import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const CardContainer = styled.div`
  width: ${pxToRem(481)};
  height: ${pxToRem(193)};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${pxToRem(24)} ${pxToRem(40)} ${pxToRem(24)} ${pxToRem(40)};

  box-sizing: border-box;
  border: ${pxToRem(1)} solid ${({ theme }) => theme.borders.outline};
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};

  box-shadow: ${({ theme }) => theme.shadows.md};
  background: ${({ theme }) => theme.colors.white};
  transition: all 0.5s ease;

  &:hover {
    transform: translateY(${pxToRem(-3)});
  }
`;

export const DocumentTitle = styled.h4`
  align-self: start;
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${pxToRem(24)};
  font-weight: 700;
`;

export const IconsContainer = styled.div`
  display: flex;
  gap: ${pxToRem(8)};
`;

/*
  Кнопка, а не картинка. По значку кликают — открывается состав версии
  документа. Картинке нельзя дать фокус с клавиатуры и нельзя нажать
  пробелом, поэтому здесь настоящая кнопка, а внутри инлайновый svg.
*/
export const Icon = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(44)};
  height: ${pxToRem(44)};
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.inkSoft};
  transition: color 0.15s ease, transform 0.15s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.brand};
    transform: translateY(${pxToRem(-3)});
  }
`;

/** Сам значок внутри кнопки: цвет приходит от неё через currentColor. */
export const IconGlyph = styled.svg`
  width: 100%;
  height: 100%;
  flex: 0 0 auto;
  color: inherit;
`;

export const IconsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
